import gql from 'graphql-tag';

export const GET_ADVERTISER_SIGNUP_DATE = gql`
  query GetAdvertiserSignupDate {
    advertiser {
      createdDate
    }
  }
`;
